import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/feature/PageMeta";
import { getLatestTopics } from "@/lib/content";

export default function NotFound() {
  const location = useLocation();
  const suggestions = getLatestTopics(3);

  return (
    <SiteLayout>
      <PageMeta
        title="页面不存在 404 · 黑料吃话"
        description="你访问的页面不存在或已被移动。可以返回首页，或前往话题归档库继续检索感兴趣的档案。"
        path="/404"
      />
      <section className="relative mt-[68px] flex flex-col items-center justify-center overflow-hidden bg-background-100 px-4 py-20 text-center md:py-28">
        <div className="paper-grid absolute inset-0 opacity-40" />
        <div className="relative mx-auto w-full max-w-8xl">
          <span className="font-heading text-[6rem] font-black leading-none text-background-300 md:text-[9rem]">
            404
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这一页没有找到对应的档案
          </h1>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            你访问的地址可能已被移动，或者这份档案尚未整理完成。
            <span className="mt-2 block font-mono text-xs text-foreground-400">{location.pathname}</span>
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/topics"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              浏览话题归档
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-background-50 px-4 py-14 md:px-8 md:py-16">
        <div className="mx-auto w-full max-w-8xl">
          <h2 className="font-heading text-lg font-semibold text-foreground-950">
            也许你会想看看这些
          </h2>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {suggestions.map((topic) => (
              <Link
                key={topic.id}
                to={`/topics/${topic.slug}`}
                className="group rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
              >
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                  {topic.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {topic.summary}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}